import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalStorageClass } from '../../../helpers/local-storage-helper';
import { ThirdPartyLoginService } from '../../../services/auth/third-party-login.service';

export type OAuthProvider = 'rba' | 'ht' | 'telemachhr';

@Component({
  selector: 'jenz-oauth-callback',
  imports: [],
  template: `<div class="callback-loading"></div>`,
  styleUrl: './oauth-callback.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OAuthCallback implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly thirdPartyLoginService = inject(ThirdPartyLoginService);

  private readonly redirectUris: Record<OAuthProvider, string> = {
    rba: 'https://web.jenz.app/oauth-callback',
    ht: 'https://web.jenz.app/ht-oauth-callback',
    telemachhr: 'https://web.jenz.app/callback-telemachhr',
  };

  ngOnInit(): void {
    const token = LocalStorageClass.retrieveTokenFromStorage();
    if (token?.length) {
      this.router.navigate(['']);
      return;
    }

    const provider = this.route.snapshot.data['provider'] as OAuthProvider;
    const code = this.route.snapshot.queryParamMap.get('code');

    if (!code) {
      this.router.navigate(['login']);
      return;
    }

    const tenantName = environment.production
      ? LocalStorageClass.getThirdPartyLoginProvider() ?? provider
      : 'jenzstaging';

    LocalStorageClass.removeThirdPartyLoginProvider();

    const request$ = provider === 'rba'
      ? this.thirdPartyLoginService.getRbaAlbaniaToken(tenantName, code)
      : this.thirdPartyLoginService.microsoft365Login(tenantName, code, this.redirectUris[provider]);

    request$.pipe(
      tap((response) => {
        if (response?.token) {
          LocalStorageClass.setToken(response.token, response.refreshToken);
          window.location.reload();
        } else {
          this.router.navigate(['login']);
        }
      })
    ).subscribe({
      error: () => this.router.navigate(['login']),
    });
  }
}
